export default __webpack_public_path__ + "static/media/loading.6ee6243b.png";